var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeizmerenaKonsumatsiaDobavyaneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,20.8c0,0.3,0.8,2.5,2.3,2.5c2.2,0,2.7-1.9,2.7-2.5c0-1.7-2.5-5.1-2.5-5.1S11.4,19.1,11.4,20.8z  M6.3,4.4V3.2H5.1v1.3H6.3z M8.8,0.6H2.5v1.3h6.3V0.6z M15.2,9.5c0-1,0.2-3.8-3.8-3.8c-4,0-8.8,0-8.8,0V4.4H0v6.3h2.5V9.5 c0,0,6.1,0,7.6,0c1.6,0,1.3,2.5,1.3,2.5h-1.3v1.3h6.3V12h-1.3C15.2,12,15.2,10.5,15.2,9.5z M21.5,4.4V1.9h-2.5v2.5h-2.5v2.5h2.5 v2.5h2.5V6.9H24V4.4H21.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeizmerenaKonsumatsiaDobavyaneIcon);
export default __webpack_public_path__ + "static/media/neizmerena_konsumatsia_dobavyane_icon.4b54328a.svg";
export { ForwardRef as ReactComponent };